import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../auth/authentication.service";
var host = environment.host;
var client_id = environment.auth.client_id;
var TokenService = /** @class */ (function () {
    function TokenService(http, auth) {
        this.http = http;
        this.auth = auth;
    }
    TokenService.prototype.validarToken = function (token) {
        var options = {
            observe: 'response',
            headers: new HttpHeaders()
                .append('client_id', client_id)
                .append('access_token', this.auth.accessToken),
            params: new HttpParams()
                .set('token', token)
        };
        return this.http
            .get(host + "/token/corporativo/v1/tokens/hash/validate", options)
            .pipe(map(function (response) {
            return {
                body: response.body
            };
        }));
    };
    TokenService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function TokenService_Factory() { return new TokenService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.AuthenticationService)); }, token: TokenService, providedIn: "root" });
    return TokenService;
}());
export { TokenService };
